import Vue from 'vue';
import Vuex from 'vuex';

import ui from './store/ui';
import administrator from './store/administrator';
import company from './store/company';
import course from './store/course';
import code from './store/code';
import invitation from './store/invitation';
import user from './store/user';
import stats from './store/stats';
import exam from './store/exam';
import tag from './store/tag'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ui,
    administrator,
    company,
    course,
    code,
    invitation,
    user,
    stats,
    exam,
    tag,
  },
});
